import { GridColumnType } from "../../data/gridColumnType";

export const myInterviewGridConfig = {
    columns: [
        {
            name: "Full Name",
            fieldName: "firstName,lastName",
            colType: GridColumnType.CUSTOM,
            renderCustomCol: (rowData) => {
                return rowData?.["firstName"] + " " + rowData?.["lastName"];
            },
        },
        {
            name: "Email Address",
            fieldName: "contactEmail",
        },
        {
            name: "Position Applied",
            fieldName: "positionName",
        },
        {
            name: "Interview Date",
            fieldName: "interviewDate",
            colType: GridColumnType.DATE,
            colSettings: {
                // isUTC: true,
                format: "DD/MM/YYYY hh:mm A ",
            },
        },
        {
            name: "Action",
            colType: GridColumnType.ACTION,
            defaultAction: {
                allowEdit: true,
                allowDelete: false
            }
        },
    ]
}